import EmptyState from 'components/EmptyState';
import Spinner from 'components/Spinner';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useSWR from 'swr';

const tabs = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'all-time', label: 'All' },
];

// const leaderboardData = [
//   { username: '23 Gidbird', score: 5004 },
//   { username: 'colinschmitz', score: 5004 },
//   { username: '23 Gidbird', score: 5004 },
//   { username: 'jenniferlopez', score: 5004 },
//   { username: 'emilydavis', score: 5004 },
//   { username: 'emilydavis', score: 5004 },
//   { username: 'robertbrown', score: 5004 },
//   { username: 'michaeljohnson', score: 5004 },
//   { username: 'sarahsmith', score: 5004 },
//   { username: 'laurawhite', score: 5004 },
//   { username: 'jamesanderson', score: 5004 },
// ];

const medalEmojis = ['🥇', '🥈', '🥉'];

const Leaderboard = () => {
  const [activeTab, setActiveTab] = useState('all-time');
  const [searchParam] = useSearchParams()
  const id = searchParam.get('game')

  const { data, isValidating } = useSWR(`/promos/give-aways/stats/${id}/leaderboard?filter-by=${activeTab}`)
  const leaderboardData = data?.data?.map(item => ({
    username: item.username,
    score: item.points,
    rank: item.rank,
    playerId: item.playerId,
  })) || [];

  return (
    <div className=" mx-auto bg-white rounded-2xl shadow-sm p-4">
      {/* Tabs */}
      <div className="flex gap-2 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            className={`px-4 py-1.5 text-sm rounded-[16px] border transition-colors
        ${activeTab === tab.value
                ? 'bg-white border-primary text-primary font-medium'
                : 'bg-white border-gray-200 text-dark'
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>


      {/* Leaderboard list */}
      <div className="divide-y text-sm border p-3 rounded-[12px] ">
        {isValidating ?
          <Spinner />
          : leaderboardData?.length ? leaderboardData.slice(0, 10).map((entry, index) => (
            <div key={index} className="flex justify-between items-center py-5 px-1">
              <div className="flex items-center gap-2">
                <span className="w-6 text-center">
                  {index < 3 ? (
                    <span>{medalEmojis[index]}</span>
                  ) : (
                    <span className="text-gray-500">{index + 1}</span>
                  )}
                </span>
                <span className="text-gray-800 font-medium">{entry.username}</span>
              </div>
              <span className="text-gray-700">{entry.score}</span>
            </div>
          )) : <EmptyState title={'No results'} />}
      </div>
    </div>
  );
};

export default Leaderboard;
